import { TaxType } from '@dave/types/dist/proto/accounting/taxType';
import {
SelectSearchOption
} from '../../dave-utils-module/select-search/components/select-search/select-search.component';
import { GetTimeFromTimestamp } from '@dave/types';
import { GRPCEntityBase } from '../helper/helper';


export class TaxTypeEntity implements GRPCEntityBase<TaxType, TaxTypeEntity>, SelectSearchOption {
    static fromBackend = (res: TaxType): TaxTypeEntity => {
        return new TaxTypeEntity(
            +res.Id,
            res.DeletedAt ? GetTimeFromTimestamp(+res.DeletedAt) : null,
            res.Name,
            res.NameForCustomer,
            res.InvoiceText,
            res.TaxPercentage,
        );
    };
    get optionLabel() {
        return this.Name;
    }
    constructor(
        public Id: number = null,
        // public PartnerId: number = null,
        // public CreatedAt: string,
        // public UpdatedAt: string,
        public DeletedAt: Date | null = null,
        public Name: string = null,
        public NameForCustomer: string = null,
        public InvoiceText: string = null,
        /**
         * in percent 19 -> 19%
         */
        public TaxPercentage: number = null,
    ) {}
    Clone(override: Partial<TaxTypeEntity> = {}): TaxTypeEntity {
        const attr = { ...this, ...override };
        return Object.assign(new TaxTypeEntity(), attr);
    }

}
